// extracted by mini-css-extract-plugin
export default {"container":"Vk-z","blurb":"Wk-z","links":"Xk-z"};